import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { AtualizacoesAudit } from 'src/app/modules/projeto-completo/models/atualizacoes-audit';
import { ProjetoCadastro } from 'src/app/modules/projeto-completo/models/projeto-cadastro.model';
import { ProjetoList } from 'src/app/modules/projeto-completo/models/projeto-list.model';
import { ProjetoPermission } from 'src/app/modules/projeto-completo/models/projeto-permission.model';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';
import { PesquisaGeralService } from 'src/app/modules/projeto-completo/services/pesquisa-geral.service';
import { ProjetoAgregadorService } from 'src/app/modules/projeto-completo/services/projeto-agregador.service';
import { AtributosProjeto } from 'src/app/shared/models/atributos-projeto.model';
import { Orgao } from 'src/app/shared/models/orgao.model';
import { Usuario } from 'src/app/shared/models/usuario.model';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';
import { MaskService } from 'src/app/shared/services/mask.service';
import { OrgaoService } from 'src/app/shared/services/orgao.service';

@Component({
  selector: 'app-agregador-cadastro-edit',
  templateUrl: './agregador-cadastro-edit.component.html',
  styleUrls: ['./agregador-cadastro-edit.component.scss']
})
export class AgregadorCadastroEditComponent extends BaseFormComponent<ProjetoList> implements OnInit{

  idProjeto: number;
  projeto: any;
  loadingCronograma: boolean;
  isLoadingBlock: boolean;
  pathRoute: string;
  menu: any[];

  form:FormGroup;
  orgaoList: Orgao[];
  usuarioList: Usuario[];
  values_actived: any;
  attrList: AtributosProjeto;
  programaPaiList:any[];
  permissions: ProjetoPermission;
  audit: AtualizacoesAudit;

  constructor(
    private myService: ProjetoAgregadorService,
    private router: Router,
    public activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private toastr: ToastrService,
    public maskService: MaskService,
    public orgaoService: OrgaoService,
    private navigation: NavigationService,
    private pesquisaGeralService: PesquisaGeralService,
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.loading();
    this.idProjeto = this.activatedRoute.snapshot.parent.parent.params.idProjeto;
    this.orgaoList = this.activatedRoute.snapshot.data["listOrgao"];
    this.usuarioList = this.activatedRoute.snapshot.data["listUsuario"];
    this.attrList = this.activatedRoute.snapshot.data["listAtributosProjeto"];
    this.values_actived = this.attrList.actived;
    this.initMenu();
    this.initForm();
    if (this.projeto && !this.projeto?.permissions.edit) {
      this.msgError("Acesso negado.", "Erro na Solicitação");
      this.navigation.back([`projetos/agregador/${this.idProjeto}/cadastro`]);
    }
  }

  initForm() {
    this.form = this.fb.group({
      title:['',  [Validators.required]],
      description:[''],
      agency_id: [null],
      manager_cpf: [null],
      manager_adjunct_cpf: [null],
      actived:['1'], //default 1 conforme legado
      pg_id: [null],
      manager_adjunct: new FormArray([]),
    });

    this.myService.getListProgramasPai()
    .subscribe((res)=>{
      this.programaPaiList = res
    });

    if (this.idProjeto) {
      this.form.patchValue(this.projeto);
      this.form.get('manager_cpf').setValue(this.projeto?.manager?.user_cpf ?? null);
      if (this.projeto?.manager_adjunct) {
        this.projeto?.manager_adjunct?.forEach((item) => {
          this.getFormArray().push(new FormControl(item.user_cpf));
        });
      }
      this.form.get('actived').setValue(this.projeto?.actived?.toString());
      this.form.get('pg_id').setValue(this.projeto?.program_pai?.id);
      this.loaded();
      this.audit = {
        pg_id: this.idProjeto
      };
    }
  }

  removeAdjunctManager(index: number) {
    this.getFormArray().removeAt(index);
  }

  addNewAdjunctManager() {
    this.getFormArray().push(new FormControl(null));
  }

  getFormArray(): FormArray {
    return this.form.get('manager_adjunct') as FormArray;
  }

  initMenu(path = null) {
    this.pathRoute = path ? path : "/projetos/agregador/" + this.idProjeto + "/";
    this.menu = [
      {
        label: "Cadastro Projetos",
        rota: "cadastro",
        active: true,
      },
      {
        label: "Cadastro " + this.projeto?.menu?.tipo_cadastro,
        rota: "produto",
        active: this.projeto?.menu?.tipo_cadastro,
      },
      {
        label: "Entregas",
        rota: "entregas",
        active: true,
      },
      {
        label: "Indicadores",
        rota: "indicadores",
        active: true,
      },
      {
        label: "Execução Orçamentaria",
        rota: "execucao-orcamentaria",
        active: true,
      },
      {
        label: "Pontos Críticos",
        rota: "pontos-criticos",
        active: true,
      }
    ]
  }

  async salvar() {
    if (this.form.valid) {

      this.loading();
      if (this.idProjeto) {
        this.addSub(
          this.myService.update(this.getDataCreate(), this.idProjeto).subscribe({
            next: (res: ProjetoCadastro) => {
              this.msgSuccess('Cadastro alterado com sucesso!');
              EventSharedService.get('auditRefresh').emit();
              EventSharedService.get('reloadLayout').emit(this);
              this.loaded();
            },
            error: (error) => {
              this.msgError(error?.error?.error)
              this.loaded();
            },
          })
        );
      } else {
        this.addSub(
          this.myService.create(this.getDataCreate()).subscribe({
            next: (res: ProjetoCadastro) => {
              this.idProjeto = res.pf_id;
              this.toastr.info('Cadastro criado com sucesso!');
              this.navigation.replace([`projetos/agregador/${this.idProjeto}/cadastro`]);
              this.loaded();
            },
            error: (error) => {
              this.msgError(error?.error?.error);
              this.loaded();
            },
          })
        );
      }
    } else {
      this.markAsDirty();
    }
  }

  getDataCreate(): ProjetoCadastro {
    let data: ProjetoCadastro;
    data = Object.assign({}, data, this.form.value);
    if( this.idProjeto != undefined ) data.id = this.idProjeto;
    return data;
  }

  confirmExcluir() {
    this.alertConfirmation().subscribe((confirmed) => {
      if (confirmed) {
        this.excluir();
      }
    });
  }

  excluir(): void {
    this.loading();
    this.myService.delete(this.projeto?.id).subscribe({
      next: (res) => {
        this.loaded();
        this.confirmation('Projeto excluído com sucesso!').subscribe(() => {
          this.navigation.replace(['projetos', 'agregador']);
        });
      },
      error: (error) => {
        this.loaded();
        this.msgError(error?.error)
      }
    });
  }

  ngOnDestroy(): void { this.unsubscribeList(); }
  isActive(route: string): boolean { return this.router.routerState.snapshot.url.includes(route); }
  editar(){ this.router.navigate([`projetos/agregador/${this.idProjeto}/cadastro/editar`]); }
  voltar() {
    this.navigation.back([`projetos/agregador/${this.idProjeto}/cadastro`]);
  }

}
